import { AccordionAnimation } from "@components/Accordion/AccordionAnimation";
import React from "react";
import { withQuestionsItem } from "./withQuestionsItem";
import { IconMinus, IconPlus, Response } from "@bared/ui";

const QuestionsItem = withQuestionsItem(
  ({
    active,
    className,
    timeAgo,
    handleClick,
    questionTitle,
    userName,
    response,
  }) => (
    <div className={className}>
      <div className="space-y-micro">
        <div>
          <h6 className="text-caption uppercase leading-caption tracking-heading">
            {userName} / {timeAgo}
          </h6>
        </div>
        <div className="relative block cursor-pointer" onClick={handleClick}>
          <p className="pr-midi text-hint leading-hint">
            <span>Q.&nbsp;</span>
            {questionTitle}
          </p>

          {response ? (
            !active ? (
              <IconPlus className="absolute right-zero top-zero w-mini" />
            ) : (
              <IconMinus className="absolute right-zero top-zero w-mini" />
            )
          ) : null}
        </div>
      </div>

      {response && (
        <AccordionAnimation active={active}>
          <Response response={response} />
        </AccordionAnimation>
      )}
    </div>
  ),
);

export default QuestionsItem;
